import * as React from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';

export default function ModalDetalleRetenciones({ show, onHide, detalle, isLoading }) {
    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center p-5">
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Cargando...</span>
                </Spinner>
            </div>
        );
    }

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Detalle de Retenciones</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {detalle && detalle.length > 0 ? (
                    detalle.map((item, index) => (
                        <div key={index} className="mb-3 p-2 border rounded">
                            <p><strong>Orden:</strong> {item.id}</p>
                            <p><strong>Régimen:</strong> {item.regimen}</p>
                            <p><strong>Alícuota:</strong> {item.alicuota}%</p>
                            <p><strong>Monto:</strong> ${item.monto}</p>
                            <p><strong>Monto a Devolver:</strong> ${item.montoADevolver}</p>
                            <p><strong>Saldo:</strong> ${item.saldo}</p>
                            <p><strong>Base Imponible:</strong> ${item.baseImponible}</p>
                        </div>
                    ))
                ) : (
                    <p>No hay retenciones para mostrar.</p>
                )}
            </Modal.Body>
            <Modal.Footer>
                <button
                    className="btn btn-sm background-rojo-megatone"
                    onClick={onHide}
                >
                    Cerrar
                </button>
            </Modal.Footer>
        </Modal>
    );
}